module.exports = __webpack_public_path__ + "static/img/Athiti-Medium.ttf.03f41bf.svg";